import './searchResultsComponent.scss';
import React, {useCallback} from 'react';
import classNames from 'clsx';
import {SEARCH_RESULTS_LIST_CLASS, SearchResultsListComponent} from './search-result-list/search-results-list';
import {
    useStateChat,
    useStateDocsCount,
    useStateExpandedProdDocumentId,
    useStateShowScrollButton,
    useStateUseAutoCorrection
} from '../search-hooks';
import {DefaultRootState, useDispatch, useSelector} from 'react-redux';
import {SearchPageType} from '../search-config';
import {HibuButton} from '../../common/hibuButton/hibuButton';
import {scrollToTop} from '../../utils/utils';
import {Icons} from '../../icons/icons';
import {fetchNextPage} from '../duck/search-actions';
import {SearchResultOverview} from './search-result-list/searchResultOverview';
import {ActiveDrawerContent} from '../search-types';


type SearchResultsComponentProps = {
    showSidebar: boolean;
    toggleShowSidebar: () => void;
};
export const SearchResultsComponent = React.memo(({showSidebar, toggleShowSidebar}: SearchResultsComponentProps) => {
    const dispatch = useDispatch();
    const showScrollButton = useStateShowScrollButton();
    const searchConfig = useSelector((state: DefaultRootState) => state.config.uiConfig.search);
    const selectedSearchResultItemId = useStateExpandedProdDocumentId();
    const docsCount = useStateDocsCount();
    const useAutoCorrection = useStateUseAutoCorrection();
    const activeDrawerContent: ActiveDrawerContent = useStateChat();

    const onFetchNextPage = useCallback(() => {
        return dispatch(fetchNextPage(SearchPageType.BASIC, useAutoCorrection));
    }, [dispatch, useAutoCorrection]);

    function renderFloatingButtonGroup() {
        return (
            <div className="floating-button-group">
                <HibuButton
                    className={'floating-button'}
                    onClick={() => {
                        scrollToTop(SEARCH_RESULTS_LIST_CLASS);
                    }}
                    icon={Icons.SCROLL_TOP}
                    visible={docsCount > 1 && showScrollButton}
                    tooltipKey={'search.label.scrollToTop'}
                />
                <HibuButton
                    className={classNames('floating-button', 'd-lg-none')}
                    onClick={() => toggleShowSidebar()}
                    icon={Icons.FILTER}
                    visible
                    tooltipKey={'facets.title'}
                />
            </div>
        );
    }

    return (
        <>
            <div
                id="hibu_result_list_column"
                className={classNames(selectedSearchResultItemId  || activeDrawerContent === ActiveDrawerContent.ASSISTANT ? '' : 'no-document-selected')}
            >
                <SearchResultOverview/>
                <SearchResultsListComponent
                    fetchMore={onFetchNextPage}
                    resultItemViewConfig={searchConfig.resultListFields}
                    showSidebar={showSidebar}
                />
                {renderFloatingButtonGroup()}
            </div>
        </>
    );
});
